// // src/components/GpsUnitForm.js
// import React, { useEffect, useState } from 'react';
// import { Formik, Form, Field } from 'formik';
// import * as Yup from 'yup';
// import { useNavigate, useParams } from 'react-router-dom';
// import axios from 'axios';
// import { useDropzone } from 'react-dropzone';
// import {
//   TextField,
//   Button,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Checkbox,
//   FormControlLabel,
//   Typography,
//   Box,
// } from '@mui/material';
// import { AiFillHome } from 'react-icons/ai';

// // Validation schema using Yup
// const validationSchema = Yup.object({
//   name: Yup.string().required('Name is required'),
//   latitude: Yup.number()
//     .required('Latitude is required')
//     .min(-90, 'Must be between -90 and 90')
//     .max(90, 'Must be between -90 and 90'),
//   longitude: Yup.number()
//     .required('Longitude is required')
//     .min(-180, 'Must be between -180 and 180')
//     .max(180, 'Must be between -180 and 180'),
//   unit_type: Yup.string().required('Unit type is required'),
//   active: Yup.boolean(),
//   number: Yup.string()
//     .required('Phone number is required')
//     .matches(/^[0-9]+$/, 'Phone number must be numeric')
//     .min(10, 'Phone number must be at least 10 digits')
//     .max(15, 'Phone number cannot exceed 15 digits'),
// });

// const GpsUnitForm = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [icon, setIcon] = useState(null);
//   const [preview, setPreview] = useState(null);

//   // Fetch data for editing
//   useEffect(() => {
//     if (id) {
//       axios
//         .get(`https://procam.pythonanywhere.com/api/gps_unit/${id}`)
//         .then((response) => {
//           const { name, latitude, longitude, unit_type, active, icon, number } =
//             response.data;
//           setIcon(icon);
//           setPreview({ name, latitude, longitude, unit_type, active, number });
//         });
//     }
//   }, [id]);

//   const { getRootProps, getInputProps } = useDropzone({
//     accept: 'image/*',
//     onDrop: (acceptedFiles) => {
//       setIcon(acceptedFiles[0]);
//       setPreview(URL.createObjectURL(acceptedFiles[0]));
//     },
//   });

//   return (
//     <Box
//       sx={{
//         padding: 2,
//         maxWidth: 400,
//         margin: 'auto',
//         border: '1px solid #ddd',
//         borderRadius: 2,
//         boxShadow: 3,
//         backgroundColor: '#f9f9f9',
//         mt: 4,
//       }}
//     >
//       <Typography
//         variant='h6'
//         align='center'
//         gutterBottom
//         sx={{ display: 'flex' }}
//       >
//         <span onClick={() => navigate('/marathon-tracker')}>
//           <AiFillHome
//             color='green'
//             style={{ cursor: 'pointer' }}
//             onClick={() => navigate('/marathon-tracker')}
//           />
//         </span>
//         <div
//           style={{
//             display: 'flex',
//             justifyContent: 'center',
//             width: '100%',
//             textDecoration: 'underline',
//             fontSize: '1.1rem',
//           }}
//         >
//           {id ? 'Edit GPS Unit' : 'Create GPS Unit'}
//         </div>
//       </Typography>
//       <Formik
//         initialValues={
//           id
//             ? preview
//             : {
//                 name: '',
//                 latitude: '',
//                 longitude: '',
//                 unit_type: '',
//                 active: false,
//                 number: '',
//               }
//         }
//         enableReinitialize
//         validationSchema={validationSchema}
//         onSubmit={async (data) => {
//           data.icon =
//             data.unit_type === 'MEDICAL CENTER'
//               ? 'medical-center.svg'
//               : data.unit_type === 'AMBULANCE'
//               ? 'ambulance.svg'
//               : data.unit_type === 'LEAD CAR'
//               ? 'icon-lead-car.svg'
//               : data.unit_type === 'TAIL CAR' && 'icon-tail-car.svg';

//           if (id) {
//             await axios.put(
//               `https://procam.pythonanywhere.com/api/gps_unit/${id}`,
//               data
//             );
//           } else {
//             await axios.post(
//               'https://procam.pythonanywhere.com/api/gps_unit/',
//               data
//             );
//           }
//           navigate('/marathon-tracker');
//         }}
//       >
//         {({ values, handleChange, setFieldValue, errors, touched }) => (
//           <Form>
//             <Box sx={{ mb: 2 }}>
//               <div>
//                 Name <span style={{ color: 'red' }}>*</span>
//               </div>
//               <TextField
//                 fullWidth
//                 name='name'
//                 value={values?.name}
//                 onChange={handleChange}
//                 error={Boolean(errors.name && touched.name)}
//                 helperText={
//                   touched.name && errors.name ? (
//                     <span style={{ color: 'red' }}>{errors.name}</span>
//                   ) : (
//                     ''
//                   )
//                 }
//               />
//             </Box>
//             <Box sx={{ mb: 2 }}>
//               <div>
//                 Latitude <span style={{ color: 'red' }}>*</span>
//               </div>
//               <TextField
//                 fullWidth
//                 name='latitude'
//                 type='number'
//                 value={values?.latitude}
//                 onChange={handleChange}
//                 error={Boolean(errors.latitude && touched.latitude)}
//                 helperText={
//                   touched.latitude && errors.latitude ? (
//                     <span style={{ color: 'red' }}>{errors.latitude}</span>
//                   ) : (
//                     ''
//                   )
//                 }
//               />
//             </Box>
//             <Box sx={{ mb: 2 }}>
//               <div>
//                 Longitude <span style={{ color: 'red' }}>*</span>
//               </div>
//               <TextField
//                 fullWidth
//                 name='longitude'
//                 type='number'
//                 value={values?.longitude}
//                 onChange={handleChange}
//                 error={Boolean(errors.longitude && touched.longitude)}
//                 helperText={
//                   touched.longitude && errors.longitude ? (
//                     <span style={{ color: 'red' }}>{errors.longitude}</span>
//                   ) : (
//                     ''
//                   )
//                 }
//               />
//             </Box>
//             <Box sx={{ mb: 2 }}>
//               <div>
//                 Phone <span style={{ color: 'red' }}>*</span>
//               </div>
//               <TextField
//                 fullWidth
//                 name='number'
//                 type='number'
//                 value={values?.number}
//                 onChange={handleChange}
//                 error={Boolean(errors.number && touched.number)}
//                 helperText={
//                   touched.number && errors.number ? (
//                     <span style={{ color: 'red' }}>{errors.number}</span>
//                   ) : (
//                     ''
//                   )
//                 }
//               />
//             </Box>
//             <Box sx={{ mb: 2 }}>
//               <FormControl fullWidth>
//                 <div>
//                   Unit Type <span style={{ color: 'red' }}>*</span>
//                 </div>
//                 <Select
//                   name='unit_type'
//                   id='unit_type'
//                   value={values?.unit_type || ''}
//                   onChange={handleChange}
//                   error={Boolean(errors.unit_type && touched.unit_type)}
//                 >
//                   <MenuItem value='MEDICAL CENTER'>MEDICAL CENTER</MenuItem>
//                   <MenuItem value='AMBULANCE'>AMBULANCE</MenuItem>
//                   <MenuItem value='LEAD CAR'>LEAD CAR</MenuItem>
//                   <MenuItem value='TAIL CAR'>TAIL CAR</MenuItem>
//                 </Select>
//                 {errors.unit_type && touched.unit_type && (
//                   <span style={{ color: 'red' }}>{errors.unit_type}</span>
//                 )}
//               </FormControl>
//             </Box>

//             <FormControlLabel
//               control={
//                 <Checkbox
//                   name='active'
//                   checked={values?.active || false}
//                   onChange={() => setFieldValue('active', !values.active)}
//                 />
//               }
//               label='Active'
//             />

//             <Button type='submit' variant='contained' color='primary' fullWidth>
//               Save
//             </Button>
//           </Form>
//         )}
//       </Formik>
//     </Box>
//   );
// };

// export default GpsUnitForm;

// src/components/GpsUnitForm.js
import React, { useEffect, useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import {
  Box,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Typography,
  FormControlLabel,
  Checkbox,
  Grid,
  Card,
  CardContent,
} from '@mui/material';
import { AiFillHome } from 'react-icons/ai';
import LayoutContainer from '../../components/LayoutContainer';
import AdminHeader from '../../components/AdminHeader';
import { filter, find, includes, toUpper } from 'lodash';
import userService from '../../services/userService';
import { toast } from 'react-toastify';

// Validation schema using Yup
const validationSchema = Yup.object({
  name: Yup.string().required('Name is required'),
  latitude: Yup.number()
    .required('Latitude is required')
    .min(-90, 'Must be between -90 and 90')
    .max(90, 'Must be between -90 and 90'),
  longitude: Yup.number()
    .required('Longitude is required')
    .min(-180, 'Must be between -180 and 180')
    .max(180, 'Must be between -180 and 180'),
  unit_type: Yup.string().required('Unit type is required').nullable(),
  active: Yup.boolean(),
  // user_name: Yup.string().required('User name is required').nullable(),
  // number: Yup.string().test(
  //   'required-or-optional',
  //   'Phone number is required',
  //   function (value) {
  //     const { unit_type } = this.parent;
  //     if (unit_type === 'MEDICAL CENTER' || unit_type === 'HOSPITAL') {
  //       return true;
  //     }
  //     return Yup.string()
  //       .matches(/^[0-9]+$/, 'Phone number must be numeric')
  //       .min(10, 'Phone number must be at least 10 digits')
  //       .max(15, 'Phone number cannot exceed 15 digits')
  //       .required('Phone is required')
  //       .isValidSync(value);
  //   }
  // ),
  user_name: Yup.string()
    .test('required-or-optional', 'User name is required', function (value) {
      const { unit_type } = this.parent;

      if (
        unit_type === 'MEDICAL CENTER' ||
        unit_type === 'HOSPITAL' ||
        unit_type === 'JUNCTION'
      ) {
        return true;
      }

      return Yup.string().required('User name is required').isValidSync(value);
    })
    .nullable(),
});

const GpsUnitForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [userList, setUseList] = useState([]);
  const [initialValues, setInitialValues] = useState({
    name: '',
    latitude: '',
    longitude: '',
    unit_type: '',
    active: false,
    number: '',
    user_name: '',
    event_id: localStorage?.getItem('event_id'),
  });

  const [unitTypes, setUnitTypes] = useState([
    'MEDICAL CENTER',
    'AMBULANCE',
    'LEAD CAR',
    'TAIL CAR',
    'HOSPITAL',
    'JUNCTION',
  ]);

  useEffect(() => {
    if (id) {
      axios
        .get(`${process.env.REACT_APP_API_URL}/gps_unit/${id}`)
        .then((response) => {
          const { name, latitude, longitude, unit_type, active, user_name } =
            response.data;
          setInitialValues({
            name,
            latitude,
            longitude,
            unit_type,
            active,
            number: find(userList, { username: user_name })?.phone,
            user_name,
          });
        });
    }
  }, [id]);

  const fetchUsers = async () => {
    const response = await userService.getUsers();
    setUseList(
      filter(
        response?.data,
        (data) =>
          includes(JSON.parse(data?.roles), 'USER') &&
          includes(JSON.parse(data?.permissions), 'AMBULANCE GPS'),
      ),
    );
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  return (
    <LayoutContainer>
      <AdminHeader
        title={id ? 'EDIT GPS UNIT' : 'ADD GPS UNIT'}
        backTo='/gpsUnits'
      />
      <Box
        className='page-content-wrapper scrollable'
        p={3}
        sx={{ display: 'flex', backgroundColor: '#efefef' }}
      >
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          enableReinitialize
          onSubmit={async (values) => {
            values.icon =
              values.unit_type === 'MEDICAL CENTER'
                ? 'medical-center.svg'
                : values.unit_type === 'AMBULANCE'
                  ? 'ambulance.svg'
                  : values.unit_type === 'HOSPITAL'
                    ? 'hospital.svg'
                    : values.unit_type === 'JUNCTION'
                      ? 'junction.png'
                      : values.unit_type === 'LEAD CAR'
                        ? 'icon-lead-car.svg'
                        : 'icon-tail-car.svg';
            try {
              if (id) {
                await axios.put(
                  `${process.env.REACT_APP_API_URL}/gps_unit/${id}`,
                  values,
                );
              } else {
                await axios.post(
                  `${process.env.REACT_APP_API_URL}/gps_unit/`,
                  values,
                );
              }
              navigate('/gpsUnits');
            } catch (error) {
              toast?.error(error?.response?.data?.message);
            }
          }}
        >
          {({ values, handleChange, setFieldValue, errors, touched }) => (
            <Form style={{ width: '50%' }}>
              <Card>
                <CardContent>
                  <Grid container spacing={3} sx={{ p: 2 }}>
                    <Grid item xs={12} sx={{ pt: '10px !important' }}>
                      <Typography variant='body2' sx={{ fontWeight: 600 }}>
                        UNIT TYPE <span style={{ color: 'red' }}>*</span>
                      </Typography>
                      <FormControl
                        fullWidth
                        error={Boolean(errors.unit_type && touched.unit_type)}
                      >
                        <Select
                          labelId='unit-type-label'
                          name='unit_type'
                          value={values.unit_type}
                          onChange={(e) => {
                            const newUnitType = e?.target?.value;
                            setFieldValue('unit_type', newUnitType);

                            if (
                              newUnitType === 'MEDICAL CENTER' ||
                              newUnitType === 'HOSPITAL' ||
                              newUnitType === 'JUNCTION'
                            ) {
                              setFieldValue('latitude', '');
                              setFieldValue('longitude', '');
                              setFieldValue('number', null);
                              setFieldValue('user_name', null);
                            } else {
                              setFieldValue('latitude', 0);
                              setFieldValue('longitude', 0);
                            }
                          }}
                          sx={{
                            backgroundColor: '#f5f5f5',
                            borderRadius: 1,
                          }}
                        >
                          {unitTypes.map((unit) => (
                            <MenuItem key={unit} value={unit}>
                              {unit}
                            </MenuItem>
                          ))}
                        </Select>
                        <FormHelperText>
                          {touched.unit_type && errors.unit_type && (
                            <span style={{ color: 'red' }}>
                              {errors.unit_type}
                            </span>
                          )}
                        </FormHelperText>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sx={{ pt: '10px !important' }}>
                      <Typography variant='body2' sx={{ fontWeight: 600 }}>
                        GPS UNIT NAME <span style={{ color: 'red' }}>*</span>
                      </Typography>
                      <TextField
                        fullWidth
                        name='name'
                        value={values.name}
                        onChange={(e) => {
                          const capitalizedValue = toUpper(e.target.value);
                          handleChange({
                            target: {
                              name: 'name',
                              value: capitalizedValue,
                            },
                          });
                        }}
                        error={Boolean(errors.name && touched.name)}
                        helperText={
                          touched.name &&
                          errors.name && (
                            <span style={{ color: 'red' }}>{errors.name}</span>
                          )
                        }
                        sx={{
                          backgroundColor: '#f5f5f5',
                          borderRadius: 1,
                          '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                              borderColor:
                                touched.name && errors.name
                                  ? '#d32f2f'
                                  : '#ccc',
                            },
                          },
                        }}
                      />
                    </Grid>

                    {values?.unit_type === 'MEDICAL CENTER' ||
                    values?.unit_type === 'HOSPITAL' ||
                    values?.unit_type === 'JUNCTION' ? (
                      <>
                        <Grid item xs={12} sx={{ pt: '10px !important' }}>
                          <Typography variant='body2' sx={{ fontWeight: 600 }}>
                            LATITUDE <span style={{ color: 'red' }}>*</span>
                          </Typography>
                          <TextField
                            fullWidth
                            name='latitude'
                            type='number'
                            value={values.latitude}
                            onChange={handleChange}
                            error={Boolean(errors.latitude && touched.latitude)}
                            helperText={
                              touched.latitude &&
                              errors.latitude && (
                                <span style={{ color: 'red' }}>
                                  {errors.latitude}
                                </span>
                              )
                            }
                            sx={{
                              backgroundColor: '#f5f5f5',
                              borderRadius: 1,
                              '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                  borderColor:
                                    touched.latitude && errors.latitude
                                      ? '#d32f2f'
                                      : '#ccc',
                                },
                              },
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sx={{ pt: '10px !important' }}>
                          <Typography variant='body2' sx={{ fontWeight: 600 }}>
                            LONGITUDE <span style={{ color: 'red' }}>*</span>
                          </Typography>
                          <TextField
                            fullWidth
                            name='longitude'
                            type='number'
                            value={values.longitude}
                            onChange={handleChange}
                            error={Boolean(
                              errors.longitude && touched.longitude,
                            )}
                            helperText={
                              touched.longitude &&
                              errors.longitude && (
                                <span style={{ color: 'red' }}>
                                  {errors.longitude}
                                </span>
                              )
                            }
                            sx={{
                              backgroundColor: '#f5f5f5',
                              borderRadius: 1,
                              '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                  borderColor:
                                    touched.longitude && errors.longitude
                                      ? '#d32f2f'
                                      : '#ccc',
                                },
                              },
                            }}
                          />
                        </Grid>
                      </>
                    ) : (
                      <Grid item xs={12} sx={{ pt: '10px !important' }}>
                        <Typography variant='body2' sx={{ fontWeight: 600 }}>
                          NAME <span style={{ color: 'red' }}>*</span>
                        </Typography>
                        <FormControl
                          fullWidth
                          error={Boolean(errors.user_name && touched.user_name)}
                        >
                          <Select
                            labelId='unit-type-label'
                            name='user_name'
                            value={values.user_name}
                            onChange={(e) => {
                              const selectedUser = e?.target?.value;
                              const phone =
                                find(userList, { username: selectedUser })
                                  ?.phone || '';
                              setFieldValue('user_name', selectedUser);
                              setFieldValue('number', phone);
                            }}
                            sx={{
                              backgroundColor: '#f5f5f5',
                              borderRadius: 1,
                            }}
                          >
                            {userList.map((user) => (
                              <MenuItem key={user?.id} value={user?.username}>
                                {user?.username}
                              </MenuItem>
                            ))}
                          </Select>
                          <FormHelperText>
                            {touched.user_name && errors.user_name && (
                              <span style={{ color: 'red' }}>
                                {errors.user_name}
                              </span>
                            )}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                      // <Grid item xs={12} sx={{ pt: '10px !important' }}>
                      //   <Typography variant='body2' sx={{ fontWeight: 600 }}>
                      //     Phone <span style={{ color: 'red' }}>*</span>
                      //   </Typography>
                      //   <TextField
                      //     fullWidth
                      //     name='number'
                      //     type='text'
                      //     value={values.number}
                      //     onChange={handleChange}
                      //     error={Boolean(errors.number && touched.number)}
                      //     helperText={
                      //       touched.number &&
                      //       errors.number && (
                      //         <span style={{ color: 'red' }}>
                      //           {errors.number}
                      //         </span>
                      //       )
                      //     }
                      //     sx={{
                      //       backgroundColor: '#f5f5f5',
                      //       borderRadius: 1,
                      //       '& .MuiOutlinedInput-root': {
                      //         '& fieldset': {
                      //           borderColor:
                      //             touched.number && errors.number
                      //               ? '#d32f2f'
                      //               : '#ccc',
                      //         },
                      //       },
                      //     }}
                      //   />
                      // </Grid>
                    )}

                    <Grid item xs={12} sx={{ pt: '10px !important' }}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            name='active'
                            checked={values.active}
                            onChange={() =>
                              setFieldValue('active', !values.active)
                            }
                          />
                        }
                        label='ACTIVE'
                      />
                    </Grid>

                    <Grid item xs={12} sx={{ pt: '0px !important' }}>
                      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                          type='submit'
                          variant='contained'
                          sx={{
                            backgroundColor: '#be210b',
                            textTransform: 'none',
                            padding: '5px 15px',
                            '&:hover': {
                              backgroundColor: '#a2180a',
                            },
                          }}
                        >
                          {id ? 'UPDATE' : 'CREATE'}
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Form>
          )}
        </Formik>
      </Box>
    </LayoutContainer>
  );
};

export default GpsUnitForm;
